import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { Router, } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { Mapper } from '@services/generics/data.mapper';
import { MapperService } from '@services/mapper.service';
import { ModalService } from '@services/modal.service';
import { StorageService } from '@services/storage.service';
import * as queryString from 'query-string';
import { BehaviorSubject, } from 'rxjs';
import { finalize, map, tap, } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../app-state/app-state.facade";
import * as i2 from "@angular/common/http";
import * as i3 from "@angular/router";
import * as i4 from "./storage.service";
import * as i5 from "./modal.service";
import * as i6 from "@angular/common";
var defaultTenant = 'Default';
var AuthService = /** @class */ (function (_super) {
    tslib_1.__extends(AuthService, _super);
    function AuthService(_appState, _http, _router, _storage, _modalService, _document) {
        var _this = _super.call(this) || this;
        _this._appState = _appState;
        _this._http = _http;
        _this._router = _router;
        _this._storage = _storage;
        _this._modalService = _modalService;
        _this._document = _document;
        _this.pendingLogout$ = new BehaviorSubject(false);
        return _this;
    }
    Object.defineProperty(AuthService.prototype, "lastTenantUsed", {
        get: function () {
            return this._storage.get(this._tenantCacheKey, defaultTenant);
        },
        set: function (value) {
            this._storage.set(this._tenantCacheKey, value || defaultTenant);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "_tenantCacheKey", {
        get: function () {
            return this._appState.authConfig.buildVersion + "-last-login-tenant";
        },
        enumerable: true,
        configurable: true
    });
    AuthService.prototype.registerTenant = function (payload) {
        return this._http.post('/account/registertenant', JSON.stringify(payload));
    };
    AuthService.prototype.externalLoginTenant = function (tenant) {
        return this._http.post('/account/ExternalLoginTenant', { tenancyName: tenant });
    };
    AuthService.prototype.logout = function (params) {
        var _this = this;
        this.pendingLogout$.next(true);
        this._modalService.closeAllDialogs();
        var logoutUrl = this._appState.authConfig.value.cloud.logoutUrl;
        if (logoutUrl) {
            this._http.get('/account/logout').subscribe(function () {
                window.location.href = logoutUrl;
            });
            return;
        }
        this._router.navigate(['/account/login'], params);
        this._appState.user.logout().pipe(finalize(function () {
            _this.pendingLogout$.next(false);
            _this._storage.set('loggedInUser', 'null');
        }), 
        // This is necessary to clear Authentication cookies in IE.
        // Otherwise the subsequent requests will have the windows identity set.
        tap(function () { return _this._document.execCommand('ClearAuthenticationCache', false); })).subscribe();
    };
    AuthService.prototype.forgotPassword = function (payload) {
        return this._http.post('/account/forgotpassword', JSON.stringify(payload));
    };
    AuthService.prototype.changePassword = function (payload) {
        return this._http.post('/account/resetpassword', JSON.stringify(payload));
    };
    AuthService.prototype.changeExpiredPassword = function (data) {
        var payload = JSON.stringify(this._toPoco(data, MapperService.changeExpiredPasswordMap));
        return this._http.post('/account/changepassword', payload);
    };
    AuthService.prototype.getExternalLoginInfo = function () {
        return this._http.get('/account/ExternalLoginInfo')
            .pipe(map(function (response) {
            if (response && response.result) {
                return {
                    tenancyName: response.result.tenancyName,
                    emailAddress: response.result.emailAddress,
                    surname: response.result.surname,
                    name: response.result.name,
                };
            }
        }));
    };
    AuthService.prototype.getExternalUserTenants = function () {
        return this._http.get('/account/ExternalUserTenants')
            .pipe(map(function (response) {
            if (response) {
                return response.result;
            }
        }));
    };
    AuthService.prototype.extractReturnUrl = function (url) {
        var returnUrl = '/';
        var navigationParams = {};
        if (url) {
            var parsedRequestedRoute = queryString.parseUrl(url);
            returnUrl = parsedRequestedRoute.url;
            if (Object.keys(parsedRequestedRoute.query).length > 0) {
                navigationParams.queryParams = parsedRequestedRoute.query;
            }
        }
        return {
            returnUrl: returnUrl,
            navigationParams: navigationParams,
        };
    };
    AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.AppStateFacade), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i4.StorageService), i0.ɵɵinject(i5.ModalService), i0.ɵɵinject(i6.DOCUMENT)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}(Mapper));
export { AuthService };
